import React from 'react';
import { Input, Modal } from '@avila-tek/ui/src';
import {
  ACTIONS,
  dataConstructor,
  filterOrderPaymentsByDate,
  tableHeaders,
} from './reducer';
import { OrderPayment } from '../../../models';
import DownloadPDFButton from '../../documentReport/DownloadPdfButton';

interface PayableReportModalProps {
  data: OrderPayment[];
  allyName: string;
  isOpen: boolean;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}

function PayableReportModal({
  data,
  allyName,
  isOpen,
  setOpen,
}: PayableReportModalProps) {
  const [orderPayments, setOrderPayments] = React.useState<OrderPayment[]>([]);
  const [state, setState] = React.useState({
    ally: '',
    end_date: '',
    start_date: '',
  });

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setState((prevState) => ({
      ...prevState,
      [name.toLowerCase()]: value,
    }));
  };

  const headerData = {
    Tipo: 'Reporte de cuentas por pagar',
    Aliado: allyName,
    Criterio: 'Obtención de registro de cuentas por pagar con rango de fecha',
  };

  React.useEffect(() => {
    if (state.start_date || state.end_date) {
      const newStartDate = state.start_date
        ? new Date(state.start_date)
        : new Date();
      const newEndDate = state.end_date ? new Date(state.end_date) : new Date();
      const filteredOrderPayments = filterOrderPaymentsByDate(
        data,
        newStartDate.toISOString(),
        newEndDate.toISOString()
      );
      // Ahora solo guardamos el filteredOrderPayments.oderpreducts
      setOrderPayments(
        filteredOrderPayments.map((orderPayment) => orderPayment)
      );
      return;
    }
    setOrderPayments(data);
  }, [state.end_date, state.start_date]);

  React.useEffect(() => {
    if (!isOpen) {
      setState({
        ally: '',
        end_date: '',
        start_date: '',
      });
    }
  }, [isOpen]);

  return (
    <Modal isOpen={isOpen} setOpen={setOpen} className="md:max-w-[60%]">
      <section>
        <div className="bg-white rounded-lg px-6 py-3 border space-y-5">
          <Modal.Title
            title="Reporte de cuentas por pagar"
            setIsOpen={setOpen}
          />
          <div className="w-full flex md:flex-row flex-col gap-5">
            <div className="w-full">
              <Input
                name={ACTIONS.ALLY}
                value={allyName}
                label="Aliado"
                type="text"
                className="bg-white"
                disabled
              />
            </div>
          </div>
          <section className="space-y-4">
            <span className="text-xs text-purple-300">
              * Por favor indique una fecha de inicio y fecha de fin para la
              crecion del reporte
            </span>
            <div className="w-full flex md:flex-row flex-col gap-5">
              <div className="w-full ">
                <Input
                  name={ACTIONS.START_DATE}
                  value={state.start_date}
                  onChange={handleChange}
                  label="Fecha de inicio"
                  type="date"
                  className="bg-white"
                />
              </div>
              <div className="w-full ">
                <Input
                  name={ACTIONS.END_DATE}
                  value={state.end_date}
                  onChange={handleChange}
                  label="Fecha de fin"
                  type="date"
                  className="bg-white"
                />
              </div>
            </div>
          </section>
          <div className="flex flex-col px-6 pb-6">
            <DownloadPDFButton
              headerData={headerData}
              data={dataConstructor(orderPayments)}
              tableHeaders={tableHeaders}
            />
          </div>
        </div>
      </section>
    </Modal>
  );
}

export default PayableReportModal;
